import type { CropVarietyConfigurationsByKey } from "../types.js";

export const customVarietyConfigurations = {
    "custom.custom": { crop: "custom", aliases: [], isExample: false, customName: true, knownClonalSelections: [] },
} as const satisfies CropVarietyConfigurationsByKey;
